import React from 'react';
import './parking.css';

const DriverCell = ({ props, type, searchTerm }) => {
  const booking = props.original[type];
  const checkDriver = _searchTerm => {
    const term = _searchTerm.toLowerCase();
    const f_name = booking.first_name == null ? null : booking.first_name.toLowerCase();
    const l_name = booking.last_name == null ? null : booking.last_name.toLowerCase();

    const f_name_startswith = booking.first_name == null ? null : f_name.startsWith(term);
    const l_name_startswith = booking.last_name == null ? null : l_name.startsWith(term);

    return term === '' ? false : f_name_startswith || l_name_startswith;
  };

  if (booking) {
    return (
      <div
        className="driver-cell-div"
        // onClick={() =>
        //   openParkingDialog("driverSummary", {
        //     ...booking,
        //     plate: props.original.plate
        //   })
        // }
        style={
          checkDriver(searchTerm)
            ? {
                backgroundColor: '#33691e',
                color: 'white',
                width: '100%',
                height: '100%',
                margin: 0,
              }
            : {}
        }>
        <div className="image-cropper">
          <img src={booking.profile_image} className="profile-image" alt="profile" />
        </div>
        <h4>
          {booking.first_name} {booking.last_name}
        </h4>
      </div>
    );
  }
  return null;
};

export default DriverCell;



// WEBPACK FOOTER //
// ./src/components/Parking/DriverCell.js